import { Entity } from "@backstage/catalog-model";
import { Progress } from "@backstage/core-components";
import { useApi } from "@backstage/core-plugin-api";
import { useTeams } from "@internal/plugin-utilities";
import { Select, MenuItem } from "@material-ui/core";
import React, { useState } from "react";
import { opsReviewApiRef } from "../../api/OpsReviewApi";

interface Props {
  repo: string;
  defaultValue?: string;
  link?: string;
}

export const TeamSelect: React.FC<Props> = ({
  repo,
  defaultValue,
  link,
}: Props): JSX.Element => {
  const api = useApi(opsReviewApiRef);
  const teams = useTeams({});
  const [team, setTeam] = useState<string>(defaultValue || "unknown");

  if (teams.loading) {
    return <Progress />;
  }

  const handleChange = async (event: any) => {
    setTeam(event?.target.value);
    await api.updateOwnership({
      repo,
      hasCatalogInfo: false,
      archived: false,
      team: event?.target.value,
      link,
    });
  };

  return (
    <Select fullWidth value={team} onChange={handleChange}>
      {teams &&
        teams.value &&
        (teams.value as Entity[]).map((t: Entity) => {
          return (
            <MenuItem value={t.metadata.name} key={t.metadata.name}>
              {t.metadata.name}
            </MenuItem>
          );
        })}
      <MenuItem value="unknown">unknown</MenuItem>
    </Select>
  );
};
